import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';

import {
  createTimeTrackingReason,
  deleteTimeTrackingReason,
  getTimeTrackingReason,
  updateTimeTrackingReason,
} from '../../../../app/store/actions/timeTrackingReasons';
import OneClickButton from '../../../../components/form/button';
import Form from '../../../../components/form/form';
import addNotification from '../../../../components/notification';
import {
  Panel,
  PanelBody, PanelFooter,
  PanelHeader,
} from '../../../../components/panel/panel';
import ROUTES from '../../../../config/routes';

class TimeTrackingReasonForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'detail',
      code: '',
      name: '',
      note: '',
      disableCode: true,
      disableName: true,
      disableNote: true,
      showCreate: false,
      showUpdate: false,
      showCancel: false,
    };
  }

  async componentDidMount() {
    await this.setMode();
    if (this.state.mode !== 'create') {
      await this.getTimeTrackingReasonSelected();
    }
  }

  getTimeTrackingReasonSelected = async () => {
    if (this.props.location.state.timeTrackingReason) {
      const { timeTrackingReason } = this.props.location.state;

      const timeTrackingReasonSelected = await this.props.getTimeTrackingReason(timeTrackingReason.id);

      if (timeTrackingReasonSelected) {
        this.setState({
          reasonId: timeTrackingReasonSelected.id,
          code: timeTrackingReasonSelected.code,
          name: timeTrackingReasonSelected.name,
          note: timeTrackingReasonSelected.note,
        });
      }
    }
  };

  setMode = () => {
    let mode;

    if (this.props.isCreate) {
      mode = 'create';
    } else if (this.props.isCopy) {
      mode = 'copy';
    } else if (this.props.isEdit) {
      mode = 'edit';
    } else if (this.props.isDetail) {
      mode = 'detail';
    }

    if (mode === 'create' || mode === 'copy') {
      this.setState({
        mode,
        disableCode: false,
        disableName: false,
        disableNote: false,
        showCreate: true,
        showUpdate: false,
        showCancel: true,
      });
    } else if (mode === 'edit') {
      this.setState({
        mode,
        disableCode: true,
        disableName: false,
        disableNote: false,
        showCreate: false,
        showUpdate: true,
        showCancel: true,
      });
    }
  };

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  createTimeTrackingReasonSubmit = async () => {
    const {
      code, name, note,
    } = this.state;

    try {
      const newTimeTrackingReason = await this.props.createTimeTrackingReason({
        code,
        name,
        note,
      });

      if (newTimeTrackingReason) {
        if (newTimeTrackingReason.success && newTimeTrackingReason.success === false) {
          await addNotification(
            'danger',
            I18n.t('BEE4258' /* Novo Motivo de Finalização de Apontamento */),
            I18n.t('BEE4259', { 0: code } /* Erro ao incluir o Motivo Finalização Apontamento %{0} */),
            'top-right',
          );
        } else {
          await addNotification(
            'success',
            I18n.t('BEE4258' /* Novo Motivo de Finalização de Apontamento */),
            I18n.t('BEE4260', { 0: code } /* Novo motivo de finalização do apontamento %{0} incluído com sucesso! */),
            'top-right',
          );

          this.props.history.push(ROUTES.TIME_TRACKING_REASON_LIST);
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE4258' /* Novo Motivo de Finalização de Apontamento */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE4258' /* Novo Motivo de Finalização de Apontamento */),
            I18n.t('BEE4259', { 0: code } /* Erro ao incluir o Motivo Finalização Apontamento %{0} */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE4258' /* Novo Motivo de Finalização de Apontamento */),
          I18n.t('BEE4259', { 0: code } /* Erro ao incluir o Motivo Finalização Apontamento %{0} */),
          'top-right',
        );
      }
    }
  };

  updateTimeTrackingReasonSubmit = async () => {
    const {
      name, reasonId, note, code,
    } = this.state;

    try {
      const updTimeTrackingReason = await this.props.updateTimeTrackingReason({
        reasonId,
        name,
        note,
      });

      if (updTimeTrackingReason) {
        if (updTimeTrackingReason.success && updTimeTrackingReason.success === false) {
          await addNotification(
            'danger',
            I18n.t('BEE4261' /* Atualizar Motivo de Finalização do Apontamento */),
            I18n.t('BEE4262', { 0: code } /* Erro ao atualizar o Motivo Finalização do Apontamento %{0}! */),
            'top-right',
          );
        } else {
          await addNotification(
            'success',
            I18n.t('BEE4261' /* Atualizar Motivo de Finalização do Apontamento */),
            I18n.t('BEE4263', { 0: code } /* Atualização do Motivo Finalização Apontamento efetuada com sucesso! */),
            'top-right',
          );

          this.props.history.push(ROUTES.TIME_TRACKING_REASON_LIST);
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE4261' /* Atualizar Motivo de Finalização do Apontamento */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE4261' /* Atualizar Motivo de Finalização do Apontamento */),
            I18n.t('BEE4262', { 0: code } /* Erro ao atualizar o Motivo Finalização do Apontamento %{0}! */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE4261' /* Atualizar Motivo de Finalização do Apontamento */),
          I18n.t('BEE4262', { 0: code } /* Erro ao atualizar o Motivo Finalização do Apontamento %{0}! */),
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      code, name, note,
    } = this.state;

    const {
      mode, disableCode, disableName, disableNote, showCreate, showUpdate, showCancel,
    } = this.state;

    let title = '';

    if (mode === 'create' || mode === 'copy') {
      title = I18n.t('BEE4258' /* Novo Motivo de Finalização de Apontamento */);
    } else if (mode === 'edit') {
      title = I18n.t('BEE4264' /* Editar Motivo de Finalização do Apontamento */);
    } else if (mode === 'detail') {
      title = I18n.t('BEE4265' /* Detalhes da Finalização do Apontamento */);
    }

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE4274' /* Apontamentos */)}</li>
            <li className="breadcrumb-item active">
              {I18n.t('BEE4266' /* Motivos para Finalização de Apontamento */)}
            </li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {title}
          </h1>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <Panel>
              <PanelHeader noButton />
              <PanelBody>
                <Form
                  noPanel
                  setValue={this.setValue}
                  inputs={(formContext) => ([
                    formContext.createInput(
                      code,
                      'code',
                      `${I18n.t('BEE82' /* Código */)}:`,
                      I18n.t('BEE4267' /* Informe o código do Motivo Finalização Apontamento */),
                      'text',
                      true,
                      disableCode,
                    ),
                    formContext.createInput(
                      name,
                      'name',
                      `${I18n.t('BEE277' /* Descrição */)}:`,
                      I18n.t('BEE4268' /* Informe a descrição do motivo de finalização do apontamento. */),
                      'text',
                      true,
                      disableName,
                    ),
                    formContext.createInput(
                      note,
                      'note',
                      `${I18n.t('BEE135' /* Observação */)}:`,
                      I18n.t('BEE136' /* Informe a observação */),
                      'text',
                      false,
                      disableNote,
                    ),
                  ])}
                />
              </PanelBody>
              <PanelFooter>
                <Link to={{ pathname: ROUTES.TIME_TRACKING_REASON_LIST, state: { dice: this.props.location.dice } }}>
                  {(showCancel
                    ? (
                      <OneClickButton
                        type="submit"
                        className="btn btn-120 btn-white p-5 m-5"
                      >
                        {I18n.t('BEE99' /* Cancelar */)}
                      </OneClickButton>
                    )
                    : (
                      <OneClickButton
                        type="submit"
                        className="btn btn-120 btn-white p-5 m-5"
                      >
                        {I18n.t('BEE137' /* Voltar */)}
                      </OneClickButton>
                    ))}
                </Link>
                {(showCreate
                    && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.createTimeTrackingReasonSubmit()}
                    >
                      {I18n.t('BEE138' /* Criar */)}
                    </OneClickButton>
                    )
                  )}
                {(showUpdate
                    && (
                    <OneClickButton
                      type="button"
                      className="btn btn-120 btn-primary p-5 m-5"
                      onClick={() => this.updateTimeTrackingReasonSubmit()}
                    >
                      {I18n.t('BEE139' /* Atualizar */)}
                    </OneClickButton>
                    )
                  )}
              </PanelFooter>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  getTimeTrackingReason: (reasonId) => dispatch(getTimeTrackingReason(reasonId)),
  createTimeTrackingReason: (timeTrackingReason) => dispatch(createTimeTrackingReason(timeTrackingReason)),
  updateTimeTrackingReason: (timeTrackingReason) => dispatch(updateTimeTrackingReason(timeTrackingReason)),
  deleteTimeTrackingReason: (reasonId) => dispatch(deleteTimeTrackingReason(reasonId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TimeTrackingReasonForm));
